import { render, staticRenderFns } from "./IntegrationStatuses.vue?vue&type=template&id=f4b9867c&scoped=true&"
import script from "./IntegrationStatuses.vue?vue&type=script&lang=js&"
export * from "./IntegrationStatuses.vue?vue&type=script&lang=js&"
import style0 from "./IntegrationStatuses.vue?vue&type=style&index=0&id=f4b9867c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b9867c",
  null
  
)

export default component.exports